import React, { useEffect, useState } from 'react';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import websitelogo from '../../../../assets/logos/websitelogo.svg';

import CallIcon from '@mui/icons-material/Call';

import ChatIcon from '@mui/icons-material/Chat';

import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import Maxprovider from '../../../../assets/logos/aboutus1.svg';

import Maxcoder from '../../../../assets/logos/aboutus2.png';

import Maxedits from '../../../../assets/logos/aboutus3.png';

import EastIcon from '@mui/icons-material/East';

import { Box, CssBaseline, Grid, Typography } from '@mui/material';

import { Link } from 'react-router-dom';

import Paper from '@mui/material/Paper';

import Button from '@mui/material/Button';

import { aboutUs } from '../../../services/api/apiManager';
import { settings as s } from '../../../services/Settings';

function AboutUs() {
	const defaultTheme = createTheme();
	const [appData, setAppData] = useState([]);

	const fetchData = async () => {
		try {
			debugger;
			const response = await aboutUs();
			setAppData(response.data);
		} catch (error) {
			console.error('Error fetching app data:', error);
		}
	};

	const [showMore, setShowMore] = useState(false);

	const handleToggle = () => {
		setShowMore((prevShowMore) => !prevShowMore);
	};
	// Call fetchData whenever needed, for example on component mount
	React.useEffect(() => {
		fetchData();
	}, []);
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/background.png')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '20px 40px',
				}}
			>
				<CssBaseline />
				<Grid container item justifyContent="center">
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={4.5}
						xl={4}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/singupbacground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundPosition: 'center',
							backgroundSize: 'cover',
							display: 'flex',
							flexDirection: 'column',
							borderRadius: '15px 0px 0px 15px',
							justifyContent: 'space-between',
							// background: '#197CCC',
							display: { sm: 'none', xs: 'none', md: 'flex', xl: 'flex' },
						}}
					>
						<Grid
							item
							sx={{
								display: 'flex',
								flex: '1',
								flexDirection: 'column',
								alignItems: 'center',
								justifyContent: 'center',
								textAlign: 'center',
							}}
						>
							<Box>
								<Typography
									gutterBottom
									variant="h5"
									sx={{
										color: 'white',
										fontSize: {
											xl: '25px',
											lg: '16px',
											md: '13px',
											sm: '13px',
											xs: '10px',
										},
										fontFamily: 'Poppins',
									}}
								>
									AT MAXREMIND
								</Typography>
								<Typography
									variant="h5"
									sx={{
										color: 'white',
										fontSize: {
											xl: '19px',
											lg: '14px',
											md: '12px',
											sm: '12px',
											xs: '10px',
										},
										fontFamily: 'Poppins',
										textAlign: 'center',
										fontWeight: '400',
									}}
								>
									We are driven by a passion for
									<br /> excellence, innovation, and positive
									<br /> impact.
								</Typography>
							</Box>
						</Grid>
						<Grid
							item
							sx={{
								display: 'flex',
								justifyContent: 'space-evenly',
								borderTop: '0.5px solid rgba(255, 255, 255, 0.40)',
								padding: '15px 50px',
							}}
						>
							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<ContactSupportIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/aboutUs'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontWeight: '700',
												fontSize: {
													xl: '15px',
													lg: '13px',
													md: '13px',
													sm: '13px',
													xs: '10px',
												},
												textDecoration: 'underline',
											}}
										>
											About Us
										</Typography>
									</Link>
								</Grid>
							</Grid>

							<Grid
								container
								alignItems="center"
								justifyContent="center"
								spacing={1} // Adjust the spacing as needed
							>
								<Grid item>
									<CallIcon sx={{ color: 'white' }} />
								</Grid>
								<Grid item>
									<Link to={'/contactUs'}>
										<Typography
											variant="body1"
											sx={{
												color: 'white',
												fontWeight: '700',
												fontSize: {
													xl: '15px',
													lg: '13px',
													md: '13px',
													sm: '13px',
													xs: '10px',
												},
												textDecoration: 'underline',
											}}
										>
											Contact Us
										</Typography>
									</Link>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Grid
						component={Paper}
						square
						item
						xs={12}
						sm={8}
						md={6}
						lg={5}
						xl={4.5}
						sx={{
							backgroundImage: `url(${require('../../../../assets/images/formbackground.png')})`,
							backgroundRepeat: 'no-repeat',
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							borderRadius: '0px 15px 15px 0px',
							'@media (max-width: 600px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
							},
							'@media (max-width: 900px)': {
								// Styles for xs and sm screens
								borderRadius: '15px',
								justifyContent: 'center',
							},
						}}
					>
						<Box
							sx={{
								margin: '15px 30px 10px 30px',
								display: 'flex',
								flexDirection: 'column',
								// alignItems: 'center',
								// justifyContent: 'flex-start',
							}}
						>
							<img
								src={websitelogo}
								alt="Your Alt Text"
								style={{
									maxWidth: '200px',
									height: 'auto',
									objectFit: 'contain',
								}}
							/>
							<Typography
								component="h1"
								variant="h5"
								sx={{
									alignSelf: 'start',
									fontSize: '25px',
									fontWeight: '600',
									mt: '5px',
								}}
							>
								About Us
							</Typography>
							<Box
								component="form"
								noValidate
								sx={{
									mt: '5px',
								}}
							>
								<Grid
									container
									spacing={2}
									justifyContent="center"
									alignItems="center"
								>
									<Grid item sx={{ margin: '5px' }}>
										{/* <Typography variant="body1">
											MaxRemind is an AI-driven IT company specializing in
											Medical Billing. We use Rule-Based Expert Systems
											technology for precise medical claims scrubbing and employ
											pattern-based NLP in our MaxAgent across MaxRemind Apps.
											{!showMore && '...'}
											{showMore && (
												<>
													{' '}
													Our mission is complete automation in medical coding
													and billing, reducing costs and enhancing efficiency.
													We also aspire to extend AI&apos;s benefits to fields
													like medical decision-making, education, food
													sciences, and sports for the betterment of humanity.
												</>
											)}
										</Typography>
										<Typography
											onClick={handleToggle}
											sx={{
												fontFamily: 'Poppins',
												fontSize: '10px',
												cursor: 'pointer',
												textDecoration: 'underlinw',
											}}
										>
											{' '}
											{showMore ? 'Show Less' : 'See More'}
										</Typography> */}
										{/* <Button onClick={handleToggle} sx={{ marginTop: '10px' }}>
											{showMore ? 'Show Less' : 'See More'}
										</Button> */}

										<Typography
											variant="body2"
											sx={{
												color: '#3C3A3A',
												fontFamily: 'Poppins',
												fontSize: '13px',
												fontStyle: 'normal',
												fontWeight: '400',
												display: {
													xs: 'block',
													sm: 'block',
													lg: 'block',
													xl: 'block',
												},
											}}
										>
											MaxRemind is an AI-driven IT company specializing in
											Medical Billing. We use Rule-Based Expert Systems
											technology for precise medical claims scrubbing and employ
											pattern-based NLP in our MaxAgent across MaxRemind Apps.
										</Typography>

										{/* The following paragraph will be displayed only on sm and xl screens */}
										<Typography
											variant="body2"
											sx={{
												color: '#3C3A3A',
												fontFamily: 'Poppins',
												fontSize: '13px',
												fontStyle: 'normal',
												fontWeight: '400',
												display: {
													xs: 'none',
													sm: 'block',
													md: 'none',
													lg: 'none',
													xl: 'block',
												},
											}}
										>
											Our mission is complete automation in medical coding and
											billing, reducing costs and enhancing efficiency. We also
											aspire to extend AI&apos;s benefits to fields like medical
											decision-making, education, food sciences, and sports for
											the betterment of humanity.
										</Typography>
									</Grid>
								</Grid>
								<Grid
									container
									sx={{ margin: '5px', overflow: 'auto', height: '300px' }}
								>
									{appData.map((app, index) => (
										<Grid
											container
											key={index}
											item
											xs={12}
											// spacing={2}
											direction="row"
											sx={{
												margin: '5px',
												padding: '10px',
												borderRadius: '7px',
												border: '0.5px solid rgba(0, 0, 0, 0.05)',
												background: '#FFF',
												boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.15)',
											}}
										>
											<Grid
												item
												xs={12}
												md={3}
												lg={3}
												xl={3}
												sm={3}
												sx={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													padding: '30px 5px',
													background: '#F6F6F6',
													borderRadius: '8px',
												}}
											>
												<img
													key={app.AppImgName}
													src={`${s.baseUrl}/${app.AppImgPath}/${app.AppImgName}`}
													alt={app.AppImgName}
													style={{ maxWidth: '50px', height: '40px' }}
												/>
											</Grid>
											<Grid
												item
												xs={12}
												md={9}
												lg={9}
												xl={9}
												sm={6}
												sx={{ padding: '10px 15px' }}
											>
												<Typography
													variant="h4"
													sx={{
														color: '#1F5099',
														fontFamily: 'Poppins',
														fontSize: '14px',
														fontStyle: 'normal',
														fontWeight: '600',
													}}
												>
													{app?.AppName}
												</Typography>
												<Typography
													variant="body2"
													sx={{
														color: '#3E3D3D',
														fontFamily: 'Poppins',
														fontSize: '11px',
														fontStyle: 'normal',
														fontWeight: '600',
													}}
												>
													{app?.AppDescription}
												</Typography>
												{/* <Link style={{ textDecoration: 'none' }}> */}
												{/* <Typography
													variant="body2"
													sx={{
														color: '#FD7702',
														fontFamily: 'Poppins',
														fontSize: '14px',
														fontStyle: 'normal',
														fontWeight: '400',
														display: 'flex',
														justifyContent: 'flex-end',
													}}
												>
													Click to download
												</Typography> */}
												{/* </Link> */}
												<Box
													sx={{ justifyContent: 'flex-end', display: 'flex' }}
												>
													<Button
														variant="contained"
														endIcon={<EastIcon />}
														sx={{
															borderRadius: '2px',
															background: '#FD7702',
															height: '22px',
															marginTop: '10px',
															'&:hover': {
																borderColor: '#FD7702',
																color: '#FD7702',
																background: 'white',
															},
														}}
														onClick={() => {
															const isAppleDevice = /iPhone|iPad|iPod/i.test(
																navigator.userAgent
															);
															const storeUrl = isAppleDevice
																? app.ASurl
																: app.PSurl;
															window.open(storeUrl, '_blank');
														}}
													/>
												</Box>
											</Grid>
										</Grid>
									))}
								</Grid>
								<Link to={'/'}>
									<Typography
										variant="body1"
										sx={{
											fontFamily: 'Poppins',
											// color: 'black',
											display: 'flex',
											justifyContent: 'flex-end',
										}}
									>
										{'Login >'}
									</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
				</Grid>
			</Grid>
		</ThemeProvider>
	);
}

export default AboutUs;
